const FORM_ACCESS_HASH_PREFIX = 'ptza-form-v1::';

class AccessPtza {

    isUnlocked(formKey, passwordHash) {
        const normalizedFormKey = this.#normalizeFormKey(formKey);
        const normalizedPasswordHash = this.#normalizePasswordHash(passwordHash);

        if (!normalizedFormKey || !normalizedPasswordHash) {
            return false;
        }

        return sessionStorage.getItem(
            this.#getStorageKey(
                normalizedFormKey,
                normalizedPasswordHash
            )
        ) === '1';
    }

    async unlock(formKey, password, passwordHash) {
        const normalizedFormKey = this.#normalizeFormKey(formKey);

        if (!normalizedFormKey) {
            return {
                ok: false,
                code: 'FORM_KEY_REQUIRED'
            };
        }

        const normalizedPassword = String(password ?? '');

        if (!normalizedPassword) {
            return {
                ok: false,
                code: 'FORM_PASSWORD_REQUIRED'
            };
        }

        const normalizedPasswordHash = this.#normalizePasswordHash(passwordHash);

        if (!normalizedPasswordHash) {
            return {
                ok: false,
                code: 'FORM_PASSWORD_HASH_REQUIRED'
            };
        }

        const candidateHash = await this.#sha256(
            `${FORM_ACCESS_HASH_PREFIX}${normalizedPassword}`
        );

        if (candidateHash !== normalizedPasswordHash) {
            return {
                ok: false,
                code: 'FORM_PASSWORD_INVALID'
            };
        }

        sessionStorage.setItem(
            this.#getStorageKey(
                normalizedFormKey,
                normalizedPasswordHash
            ),
            '1'
        );

        return {
            ok: true,
            code: null
        };
    }

    lock(formKey, passwordHash) {
        const normalizedFormKey = this.#normalizeFormKey(formKey);
        const normalizedPasswordHash = this.#normalizePasswordHash(passwordHash);

        if (!normalizedFormKey || !normalizedPasswordHash) {
            return false;
        }

        sessionStorage.removeItem(
            this.#getStorageKey(
                normalizedFormKey,
                normalizedPasswordHash
            )
        );

        return true;
    }

    #normalizeFormKey(formKey) {
        return String(formKey ?? '').trim();
    }

    #normalizePasswordHash(passwordHash) {
        return String(passwordHash ?? '')
            .trim()
            .toLowerCase();
    }

    #getStorageKey(formKey, passwordHash) {
        return [
            'ptza-form-access',
            formKey,
            passwordHash.slice(0, 12)
        ].join(':');
    }

    async #sha256(value) {
        const data = new TextEncoder().encode(
            String(value ?? '')
        );

        const digest = await crypto.subtle.digest(
            'SHA-256',
            data
        );

        return Array
            .from(new Uint8Array(digest))
            .map(
                byte => byte
                    .toString(16)
                    .padStart(2, '0')
            )
            .join('');
    }
}

export const ptzaAccess = new AccessPtza();
